import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';

export default function MotionMessage({
    message,
    position,
    duration = 5000,
    onClose,
}: {
    message: string;
    position:
        | 'top-right'
        | 'top-left'
        | 'bottom-right'
        | 'bottom-left'
        | 'below'
        | 'above';
    duration?: number;
    onClose?: () => void;
}) {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            if (onClose) {
                onClose();
            }
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    if (!visible) {
        return null;
    }

    const positionClasses = {
        'top-right': 'fixed top-4 right-4 z-50',
        'top-left': 'fixed top-4 left-4 z-50',
        'bottom-right': 'fixed bottom-4 right-4 z-50',
        'bottom-left': 'fixed bottom-4 left-4 z-50',
        below: 'absolute top-full left-0 mt-2 w-full z-50',
        above: 'absolute bottom-full left-0 mb-2 w-full z-50',
    };

    return (
        <motion.div
            animate={{ opacity: 1, y: 0 }}
            className={clsx(
                'bg-gray-900 text-white px-4 py-2 rounded-lg shadow-lg flex items-center',
                positionClasses[position],
            )}
            exit={{ opacity: 0, y: -10 }}
            initial={{ opacity: 0, y: -10 }}
        >
            <span>{message}</span>
        </motion.div>
    );
}
